module.exports = "/packs/images/accessibility~4dd6191813aecfc1cdaeba97bc7af752.svg";